<header>
  <ul #slidesElementRef class="slides">
    @for (slide of slides(); track slide; let i = $index) {
      <li class="slide" id="slide-{{ i }}">
        @if (slide.image) {
          <app-image [image]="slide.image" [isPriority]="true" />
        }
        <div class="content-wrapper">
          <div class="row container bottom">
            <div class="col-lg-12 col-xs-12 end-lg end-xs">
              @if (slide.link; as link) {
                @if (link.url && link.label) {
                  <a [routerLink]="link.url" class="link">{{ link.label }}</a>
                }
              }
            </div>
          </div>
        </div>
      </li>
    }
  </ul>
  <div class="content-wrapper content-wrapper-test">
    <div></div>
    <div class="row container">
      <div class="col-lg-6 col-xs-12">
        <div class="content">
          @if (title()) {
            <app-title [titles]="[title()]" />
          }
          <div class="slide-nav">
            <i
              (click)="onPrev(slides().length)"
              [iconName]="'ARROW_LEFT'"
              class="cursor--pointer"
              color="WHITE"
              size="32px"
              title="prev"></i>
            <i
              (click)="onNext(slides().length)"
              [iconName]="'ARROW_RIGHT'"
              class="cursor--pointer"
              color="WHITE"
              size="32px"
              title="next"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
